module.exports = __webpack_public_path__ + "jtails-build/img/image@2.856c1596.jpg";